<template>
  <div>
    <!-- header-->
    <headertop></headertop>
    <el-row class="main" style="padding-top: 1.875rem;">
      <el-row>
        <el-row style="width: 40%;float: right;">
           <el-input placeholder="全文检索" v-model="input" class="input-with-select" style="width: 100%;" @keyup.enter.native="search_click()">
            </el-input>
        </el-row>
      </el-row>
      <el-row>
         <span v-if="show!='1'" @click="show_type()" style="cursor: pointer;color: blue;">
           返回目录
         </span>
          <router-link style="text-decoration: none;float: right;color: red;margin-top: 0.625rem;"  to="statute_map?num=">查看地图</router-link>
      </el-row>


      <!-- <el-row>
      //目录
        <span v-for="(item,i) in list_info.type_list" >
        <div class="tixing" ></div>
        {{item.name}}
        </span>
      </el-row> -->

      <el-row >
        <el-row style="min-height: calc(100vh - 330px);">
          <el-row v-if="show=='1'">
            <el-row>
              <!-- <div v-for="(item,i) in list_info.type_list" :key="i" style="float: left">
                <span class="tixing" style="float: left;display: flex;justify-content: center;align-items: center;">
                  <span style="float: left"> {{item.name}}</span>
                </span>

              </div> -->
              <el-tag
                  v-for="(item, index) in list_info.type_list"
                  :key="index"
                  :class="tag_bg[index-1]"
                  style="margin: 0 0.625rem;cursor: pointer;"
                  @click="type_tag(item,index)"
                   >
                   <i class="el-icon-folder-opened" style="margin-right: 5px;"></i>
                  <!-- {{ item }} -->
                  <span style="">
                    {{ item }}
                  </span>
                </el-tag>

                <!-- <i class="el-icon-folder-opened" v-for="(item, index) in list_info.type_list"  @click="type_tag(item,index)" :class="tag_bg[index]" style="margin: 0 0.625rem;cursor: pointer;"> {{ item.name }}</i> -->
                <!-- <h3 v-for="(item, index) in list_info.type_list" style="margin: 0 0.625rem;cursor: pointer; float: left;">
                  <i class="el-icon-folder-opened"   @click="type_tag(item,index)" :class="tag_bg[index]" > <span style="letter-spacing: 0.3125rem;margin-left: 0.3125rem;">{{ item }}</span></i>
                </h3> -->

            </el-row>
            <!-- <el-col  :span="2" :offset="1" class="shou"  v-for="(item,i) in list_info.list.data" :key="i" >
              <div style="margin-top: 1.25rem;" @click="book_info(item)">
                <img  src="../../../assets/book_b.jpg" style="width: 100%;" />
                <span style="min-height: 1.875rem;text-align: center;font-size: 0.6875rem;word-break: break-all; text-overflow: ellipsis;display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 2;  overflow: hidden;width: 100%;" >
                {{item.name}}</span>
              </div>
            </el-col> -->
            <el-row v-for="(item,i) in list_info.list" :key="i" >
              <el-row v-if="tag_bg_show=='0'" style="margin-top: 1.25rem;display: flex;justify-content: center;align-items: center;">
                <el-col :span="2">
                   <h2 style="text-align: center;font-weight: 400;">{{item.name}}</h2>
                 </el-col>
                 <!--边框-->
                 <el-col  v-if="item.child.length==0" :span="22"  :class="content_c_num[tag_bg_show]"  >
                    <el-row style="height: 3.75rem;display: flex;justify-content: center;align-items: center; font-weight: 400;">
                      <span>暂无内容，尽情期待</span>
                    </el-row>
                  </el-col>
                <el-col  v-else-if="0<item.child.length>3" :span="22"  :class="content_c_num[tag_bg_show]"  >
                   <el-row>
                     <el-row  >
                       <el-col  :span="11"  v-for="(item_c,p) in item.child" :key="p"  style="margin-left: 0.625rem;">
                         <h3 style="font-weight: 400;margin-left: 0.625rem;" @click="book_info_mulu(item_c)" >{{item_c.name}}</h3>
                       </el-col>
                     </el-row>
                   </el-row>
                 </el-col>
                 <el-col  v-else :span="22"  :class="content_c_num[tag_bg_show]">
                   <el-row>
                     <el-row  >
                       <el-col  :span="11"  v-for="(item_c,p) in item.child" :key="p" style="margin-top: 0.625rem;margin-left: 0.625rem;">
                         <h3 style=" font-weight: 400;" @click="book_info_mulu(item_c)">{{item_c.name}}</h3>
                       </el-col>
                     </el-row>
                   </el-row>
                   <!-- <span style="margin-top: 1.25rem;margin-bottom: 0.625rem; color: red;float: right;margin-right: 1.25rem;" v-if="item.more">
                     <span  v-if="item.type==1"  @click="get_book_all(item.num,i)"><i class="el-icon-caret-bottom"></i>点击查看更多</span>
                     <span  v-else  @click="book_type(item.num,i)" style="color: #0042a2;"> <i class="el-icon-caret-top"></i>点击收起</span>
                   </span> -->
                   <!-- <el-row style="margin-top: 1.25rem;margin-bottom: 0.625rem; text-align: center;float: right;margin-right: 0.625rem;" v-if="item.more">
                     <el-button size="mini" round  type="primary" v-if="item.type==1"  @click="get_book_all(item.num,i)"><i class="el-icon-caret-bottom"></i>点击查看更多</el-button >
                     <el-button size="mini" round  type="primary" v-else  @click="book_type(item.num,i)"> <i class="el-icon-caret-top"></i>点击收起</el-button>
                   </el-row> -->
                 </el-col>
                 <el-col   :span="2" style="float: right;">
                   <el-row style="margin-top: 1.25rem;margin-bottom: 0.625rem; text-align: center;float: right;margin-right: 0.625rem;" v-if="item.more">
                     <el-button size="mini" round  type="primary" v-if="item.type==1"  @click="get_book_all(item.num,i)"><i class="el-icon-caret-bottom"></i>展开</el-button >
                     <el-button size="mini" round  type="primary" v-else  @click="book_type(item.num,i)"> <i class="el-icon-caret-top"></i>收起</el-button>
                   </el-row>
                 </el-col>
              </el-row>

              <el-row v-else-if="tag_bg_show=='1'" style="margin-top: 1.25rem;display: flex;justify-content: center;align-items: center;">
                <el-col :span="2">
                   <h2 style="text-align: center;font-weight: 400;">{{item.name}}</h2>
                 </el-col>
                 <!--边框-->
                 <el-col  v-if="item.child.length==0" :span="22"  :class="content_c_num[tag_bg_show]" >
                    <el-row style="height: 3.75rem;display: flex;justify-content: center;align-items: center; font-weight: 400;">
                      <span>暂无内容，尽情期待</span>
                    </el-row>
                  </el-col>
                <el-col  v-else-if="0<item.child.length>3" :span="22"  :class="content_c_num[tag_bg_show]"  >
                   <el-row>
                     <el-row  >
                       <el-col  :span="11"  v-for="(item_c,p) in item.child" :key="p" >
                         <h3 style="font-weight: 400;" @click="book_info_mulu(item_c)" >{{item_c.name}}</h3>
                       </el-col>
                     </el-row>
                   </el-row>
                 </el-col>
                 <el-col  v-else :span="22"  :class="content_c_num[tag_bg_show]"  >
                   <el-row>
                     <el-row  >
                       <el-col  :span="11"  v-for="(item_c,p) in item.child" :key="p" style="margin-top: 0.625rem;margin-left: 0.625rem;">
                         <h3 style="font-weight: 400;" @click="book_info_mulu(item_c)">{{item_c.name}}</h3>
                       </el-col>
                     </el-row>
                   </el-row>
                   <!-- <span style="margin-top: 1.25rem;margin-bottom: 0.625rem; color: red;float: right;margin-right: 1.25rem;" v-if="item.more">
                     <span  v-if="item.type==1"  @click="get_book_all(item.num,i)"><i class="el-icon-caret-bottom"></i>点击查看更多</span>
                     <span  v-else  @click="book_type(item.num,i)" style="color: #0042a2;"> <i class="el-icon-caret-top"></i>点击收起</span>
                   </span> -->
                 </el-col>
                 <el-col :span="2">
                   <el-row style="margin-top: 1.25rem;margin-bottom: 0.625rem; text-align: center;float: right;margin-right: 0.625rem;" v-if="item.more">
                     <el-button size="mini" round  type="primary" v-if="item.type==1"  @click="get_book_all(item.num,i)"><i class="el-icon-caret-bottom"></i>展开</el-button >
                     <el-button size="mini" round  type="primary" v-else  @click="book_type(item.num,i)"> <i class="el-icon-caret-top"></i>收起</el-button>
                   </el-row>
                 </el-col>
              </el-row>

              <el-row v-else-if="tag_bg_show=='2'" style="margin-top: 1.25rem;display: flex;justify-content: center;align-items: center;">
                <el-col :span="2">
                   <h2 style="text-align: center;font-weight: 400;">{{item.name}}</h2>
                 </el-col>
                 <!--边框-->
                 <el-col  v-if="item.child.length==0" :span="22"  :class="content_c_num[tag_bg_show]"  >
                    <el-row style="height: 3.75rem;display: flex;justify-content: center;align-items: center; font-weight: 400;">
                      <span>暂无内容，尽情期待</span>
                    </el-row>
                  </el-col>
                <el-col  v-else-if="0<item.child.length>3" :span="22"  :class="content_c_num[tag_bg_show]" style=" margin-left: 0.625rem;" >
                   <el-row>
                     <el-row  >
                       <el-col  :span="10"  v-for="(item_c,p) in item.child" :key="p" >
                         <h3 style="lfont-weight: 400;" @click="book_info_mulu(item_c)" >{{item_c.name}}</h3>
                       </el-col>
                     </el-row>
                   </el-row>
                 </el-col>
                 <el-col  v-else :span="22"  :class="content_c_num[tag_bg_show]">
                   <el-row>
                     <el-row  >
                       <el-col  :span="10" v-for="(item_c,p) in item.child" :key="p" style="margin-top: 0.625rem;  margin-left: 0.625rem;">
                         <h3 style=" font-weight: 400;" @click="book_info_mulu(item_c)">{{item_c.name}}</h3>
                       </el-col>
                     </el-row>
                   </el-row>
                   <!-- <span style="margin-top: 1.25rem;margin-bottom: 0.625rem; color: red;float: right;margin-right: 1.25rem;" v-if="item.more">
                     <span  v-if="item.type==1"  @click="get_book_all(item.num,i)"><i class="el-icon-caret-bottom"></i>点击查看更多</span>
                     <span  v-else  @click="book_type(item.num,i)" style="color: #0042a2;"> <i class="el-icon-caret-top"></i>点击收起</span>
                   </span> -->

                 </el-col>
                 <el-col :span="2">
                   <el-row style="margin-top: 1.25rem;margin-bottom: 0.625rem; text-align: center;float: right;margin-right: 0.625rem;" v-if="item.more">
                     <el-button size="mini" round  type="primary" v-if="item.type==1"  @click="get_book_all(item.num,i)"><i class="el-icon-caret-bottom"></i>展开</el-button >
                     <el-button size="mini" round  type="primary" v-else  @click="book_type(item.num,i)"> <i class="el-icon-caret-top"></i>收起</el-button>
                   </el-row>
                 </el-col>
              </el-row>
            </el-row>
          </el-row>
          <el-row v-else>
            <el-empty description="很遗憾,未找到您想要搜索的内容" v-if=" list_info.selest_list.length==0"></el-empty>
            <el-row v-for="(item,i) in list_info.selest_list" :key="i" style="margin-top: 1.25rem;">
                <!-- <span style="color: white; cursor: pointer;background-color: rgb(51, 99, 151); font-size: 0.9375rem; padding: 0.3125rem;letter-spacing: 0.25rem;"  >法规文件</span> -->
                <span style="color: #0042a2;cursor: pointer; font-size: 0.9375rem; padding: 0.3125rem;letter-spacing: 0.125rem;" v-html="item.book"  @click="book_info(item)" ></span>
                <el-row v-html="item.passage" class="selest_con" style="margin-top: 0.625rem;"  @click="book_info(item)"></el-row>
                <el-row class="selest_con">
                  <el-row  class="overstep" v-html="item.content" style="color#333;"></el-row>
                </el-row>
            </el-row>
          </el-row>
        </el-row>
        <div class="block center" v-if="show!='1'">
          <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
            :current-page="list_info.currentPage" :page-sizes="[6, 12, 24, 48]" :page-size="list_info.pageSize"
            layout="total, sizes, prev, pager, next, jumper" :total="list_info.total">
          </el-pagination>
        </div>
      </el-row>
    </el-row>
    <!-- footer -->
    <footerbom></footerbom>

  </div>
</template>

<script>
  import Header from '../../../components/index/public/NavHeader.vue';
  import Footer from '../../../components/index/public/NavFooter.vue';
  export default {
    data() {
      return {
        tag_bg: ['bg1', 'bg2', 'bg3', 'bg4', 'bg5'],
        content_c_num:['content_c_0','content_c_1','content_c_2',],
        tag_bg_show:'0',
        show:'1',
        input:'',
        input_selest:'1',
        list_info:{
          type_list:[],
          list:[],
          currentPage:1, // 当前页码
          total:0, // 总条数
          pageSize:6,
          selest_list:[],//内容搜索数组
          add:'',
          type:'0',
          list_child:'',
        }

      }
    },

    components: {
      headertop: Header,
      footerbom: Footer
    },
    mounted:function(){
      this.get_info()
    },
    methods: {
      type_tag(item,i){
        this.list_info.add=Object.keys(this.list_info.type_list)[i-1]
        this.list_info.list=[]
        this.list_info.list_child=''
        this.list_info.type='0'
        this.get_info()
        this.tag_bg_show=i-1
      },
      show_type(){
        let _this=this
        _this.input=''
        _this.input_selest='1'
        _this.show='1'
        _this.list_info.currentPage = 1
        _this.list_info.pageSize = 6
        _this.get_info()
      },
      goback(){
        this.list_info.list=[]
      },
      book_info(item){
        if(this.show=='1'){
          window.open('/statute_content?book='+item.num+'&passage_num='+''+'&keyword='+'')
        }else{
          window.open('/statute_content?book='+item.book_num+'&passage_num='+item.passage_num+'&keyword='+this.input)
        }

      },
      book_info_con(item,item_p){
        window.open('/statute_content?book='+item.num+'&passage_num='+item_p.num+'&keyword='+'')
      },
      book_info_mulu(item){
        window.open('/statute_content?book='+item.book+'&passage_num='+''+'&keyword='+'')
      },
      get_info(){
        let _this = this;
          _this.axios
        .get("/v2/user_resource/book",
        {params:{type:_this.list_info.type,limit:2,add: _this.list_info.add}})
        .then(function (res) {
          if (res.status == "200") {
            if (res.data.code == "1") {
              if(_this.list_info.add==''){
                _this.list_info.type_list=res.data.data
                _this.list_info.add=Object.keys(res.data.data)[0]
                _this.get_info()
                return
              }
              if(_this.list_info.list.length==0){
                _this.list_info.list=res.data.data
                for (let i = 0; i < _this.list_info.list.length; i++) {
                  _this.list_info.list[i]['type']=1
                  _this.list_info.list[i]['child_tow']=_this.list_info.list[i].child
                }
                return
              }

              if(_this.list_info.list_child !=''){
               _this.list_info.list[_this.list_info.list_child].child=res.data.data
               _this.list_info.list[_this.list_info.list_child]['child_all']=res.data.data
               _this.list_info.list[_this.list_info.list_child].type=2
              }else if(_this.list_info.list_child==0){
                _this.list_info.list[_this.list_info.list_child].child=res.data.data
                _this.list_info.list[_this.list_info.list_child]['child_all']=res.data.data
                _this.list_info.list[_this.list_info.list_child].type=2
              }




              // _this.list_info.list=res.data.data

              // _this.get_book('1')
              // for (let i = 0; i < _this.list_info.list.length; i++) {
              //   _this.list_info.list[i]['type']=1
              //   _this.list_info.list[i]['child_tow']=_this.list_info.list[i].child
              // }
            } else {
              _this.$message.error(res.data.msg)
            }
          } else {
            _this.$message.error("服务器内部错误")
          }
        });
      },
      // get_book(num){
      //   let _this = this;
      //     _this.axios
      //   .get("/v2/user_resource/book",
      //   {params:{type:0,limit:2,add:num}})
      //   .then(function (res) {
      //     if (res.status == "200") {
      //       if (res.data.code == "1") {
      //         _this.list_info.list=res.data.data
      //         for (let i = 0; i < _this.list_info.list.length; i++) {
      //           _this.list_info.list[i]['type']=1
      //           _this.list_info.list[i]['child_tow']=_this.list_info.list[i].child
      //         }
      //       } else {
      //         _this.$message.error(res.data.msg)
      //       }
      //     } else {
      //       _this.$message.error("服务器内部错误")
      //     }
      //   });
      // },
      get_book_all(num,i){
        let _this = this;
        _this.list_info.type=num
        _this.list_info.list_child=i
        _this.get_info()
        //   _this.axios
        // .get("/v2/user_resource/book",
        // {params:{type:num,limit:2}})
        // .then(function (res) {
        //   if (res.status == "200") {
        //     if (res.data.code == "1") {
        //       _this.list_info.list[i].child=res.data.data
        //       _this.list_info.list[i]['child_all']=res.data.data
        //       _this.list_info.list[i].type=2
        //     } else {
        //       _this.$message.error(res.data.msg)
        //     }
        //   } else {
        //     _this.$message.error("服务器内部错误")
        //   }
        // });
      },
      book_type(num,i){
        let _this=this
        _this.list_info.list[i].type=1
        _this.list_info.list[i].child=_this.list_info.list[i].child_tow
      },
      handleSizeChange(val) {
        this.list_info.currentPage = 1
        this.list_info.pageSize = val
        if(this.show=='1'){
          this.get_info()
        }else{
          this.selestlist()
        }

      },
      handleCurrentChange(val) {
        this.list_info.currentPage = val
        if(this.show=='1'){
          this.get_info()
        }else{
          this.selestlist()
        }
      },
      search_click(){
        this.list_info.currentPage = 1
        this.list_info.pageSize = 6
        this.show='2'
        this.selestlist()

      },
      selestlist(){
        let _this=this
          _this.axios
        .get("/v2/user_resource/book_info_search",
        {params:{limit:_this.list_info.pageSize,page:_this.list_info.currentPage,keyword:_this.input}})
        .then(function (res) {
          if (res.status == "200") {
            if (res.data.code == "1") {
              _this.list_info.selest_list=res.data.data.data
              _this.list_info.pageSize=res.data.data.per_page
              _this.list_info.total=res.data.data.total
              _this.list_info.current_page=res.data.data.current_page
              for(let i=0;i<_this.list_info.selest_list.length;i++){
                _this.list_info.selest_list[i].content=_this.Highlight(_this.list_info.selest_list[i].content)
                _this.list_info.selest_list[i].book=_this.Highlight(_this.list_info.selest_list[i].book)
                _this.list_info.selest_list[i].passage=_this.Highlight(_this.list_info.selest_list[i].passage)

              }
            } else {
              _this.$message.error(res.data.msg)
            }
          } else {
            _this.$message.error("服务器内部错误")
          }
        });
      },
      Highlight(content){
        let _this=this
        // var bgColor=red
        var sText = content.replace(_this.input, "<span  style='color: #d30b15;'>" + _this.input + "</span>")
        return sText
      }

    },
  }
</script>

<style scoped>
  .content_c_0{
    border:2px solid rgb(244, 166,166);border-radius: 0.875rem;font-weight: 400;color: #999999;
    cursor: pointer;
  }
  .content_c_1{
    border:2px solid rgb(214, 166,211);border-radius: 0.875rem;font-weight: 400;color: #999999;
    cursor: pointer;
  }
  .content_c_2{
    border:2px solid rgb(153, 208,223);border-radius: 0.875rem;font-weight: 400;color: #999999;
    cursor: pointer;
  }
  .content_c_3{
    border:2px solid rgb(241, 184,127);border-radius: 0.875rem;font-weight: 400;color: #999999;
    cursor: pointer;
  }
  .content_c_4{
    border:2px solid rgb(154,192,230);border-radius: 0.875rem;font-weight: 400;color: #999999;
    cursor: pointer;
  }
  .bg1{ background: rgb(244, 166,166);
  color: black;
  }
  .bg2{ background: rgb(214, 166,211);
  color: black;}
  .bg3{ background: rgb(153, 208,223);
  color: black;}
  .bg4{ background:  rgb(241, 184,127);
  color: black;}
  .bg5{ background:  rgb(154,192,230);
  color: black;}
  /* .bg1{ color: rgb(244, 166,166);
  }
  .bg2{ color: rgb(214, 166,211);}
  .bg3{ color: rgb(153, 208,223);}
  .bg4{ color:  rgb(241, 184,127);}
  .bg5{ color: rgb(154,192,230);} */

 .tixing{
   width:100px;
   height:0;
   border-width:0 15px 50px 15px;
   border-style:none solid solid;
   border-color:transparent transparent red;
  }
  .selest_con{
     border: 1px solid #ccc;
     padding: 0.625rem 0.9375rem;
     letter-spacing: 0.25rem;
  }
  .overstep{
  overflow:hidden;
  text-overflow:ellipsis;
  display:-webkit-box;
  -webkit-box-orient:vertical;
  -webkit-line-clamp:1;
  }
  .shou{
    cursor: pointer;
  }
  .main {
    min-height: calc(100vh - 200px);
    width: 70%;
    padding: 20px;
    margin: 0 15%;
    z-index: 100;
    background-color: white;
  }

  h1 {
    margin: 0;
  }

  /* 分页 */
  .block {
    margin: 30px 0;
  }
  .el-select .el-input {
      width: 130px;
    }
    .input-with-select .el-input-group__prepend {
      background-color: #fff;
    }
  >>> .el-select .el-input__inner{
     cursor: pointer;
     width:7.5rem;
   }
</style>



// WEBPACK FOOTER //
// src/view/index/Statute/statute.vue